import React from "react";
import "./PantryHeroMini.css";
import Navbar from "../../Header/Navbar";
import { Link } from "react-router-dom";

const PantryHero = () => {
  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
      <section className="pantry-mini-hero">
        <div className="pantry-mini-container">

          {/* Title */}
          <h1 className="pantry-mini-title">Pantry Services</h1>

          {/* Breadcrumb */}
          <p className="pantry-mini-breadcrumb">
            <Link to="/" className="pantry-mini-link">Home</Link>
            <span>-</span>

            <Link to="/services" className="pantry-mini-link">Our Services</Link>
            <span>-</span>

            <Link
              to="/corporate-pantryservices"
              className="pantry-mini-link"
            >
              Pantry Services
            </Link>
          </p>

        </div>
      </section>

      {/* TAG BELOW HERO */}
     
    </>
  );
};

export default PantryHero;
